/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Document, Page, pdfjs } from 'react-pdf';
import classnames from 'classnames';
import AddCircleOutlineRoundedIcon from '@material-ui/icons/AddCircleOutlineRounded';
import RemoveCircleOutlineRoundedIcon from '@material-ui/icons/RemoveCircleOutlineRounded';
import NavigateNextOutlinedIcon from '@material-ui/icons/NavigateNextOutlined';
import NavigateBeforeOutlinedIcon from '@material-ui/icons/NavigateBeforeOutlined';
import fullscreen from '../../../../icons/fullscreen.png';
import Clickable from '../../../../components/clickable/Clickable';
import styles from './displayPdf.module.scss';
import Loading from '../../../../components/loading';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


class DisplayPDF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      numPages: null,
      pageNumber: props.pageNumberProps,
      scale: 1.0,
      showControls: false
    };
  }

  onDocumentLoadSuccess = ({ numPages }) => {
    const { setNumPages } = this.props;
    this.setState({ numPages });
    if (setNumPages) {
      setNumPages(numPages);
    }
  };

  render() {
    const elem = document?.getElementById('pdf');

    function openFullscreen() {
      if (elem?.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem?.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      } else if (elem?.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
    }

    const handelView = () => {
      openFullscreen();
      this.setState({ showControls: true });
    };

    const handelZoom = () => {
      const { adp } =this.props;
      const { scale } = this.state;
      if (adp) {
        if (scale < 1.4) this.setState({ scale: scale + 0.2 });
      } else this.setState(prevState => ({ scale: Math.min(prevState.scale + 0.2, 5.0) }));
    };

    const handelZoomOut = () => {
      this.setState(prevState => ({ scale: Math.max(prevState.scale - 0.2, 0.5) }));
    };

    const exitFullScreen = () => {
      this.setState({ scale: 1.0 });
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
      this.setState({ showControls: false });
    };

    const fullscreenchanged = () => {
      if (document?.fullscreenElement === null) {
        this.setState({ showControls: false, scale: 1.0 });
      }
    };

    document.addEventListener('fullscreenchange', fullscreenchanged);

    const { pdf, handleNextPrev, pageNumberProps, adp, translation, nextSectionId, subSection, toggle, next_section,
      sectionIndex, subSectionIdIndex, prevSectionId, prevSubSectionId, showPrevious, parentSection,
      params, numPagesProps } = this.props;
    const { numPages, pageNumber, showControls, scale } = this.state;
    let { width } = window.screen;
    if (adp) {
      if (width>=1000) {
        width=1000;
      } else if (width>650) {
        width -=150;
      } else {
        width -=100;
      }
    }

    return (
      <>
        <div className={`${styles.mainCarousel} ${styles.centeredSlides}`}>
          {/* {!adp && ( */}
          <div className={styles.fullScreenText}>
            <img src={fullscreen} alt="fullscreen" className={styles.fullScreenIcon} onClick={() => { handelView(); }} />
            <Clickable onClick={() => { handelView(); }}>
              <p style={{ margin: 0 }}>{translation?.fScreen}</p>
            </Clickable>
          </div>
          {/* )} */}
          <div id="pdf" key={pdf.id} className={
            showControls
              ? `${styles.pdfContaier} ${styles.fullscreenMode}`
              : styles.pdfContaier
          }>
            {showControls && (
              <>
                <div className={styles.fixedControls}>
                  <div className={styles.exitfullScreenText}>
                    <div className={styles.zoomControls}>
                      <AddCircleOutlineRoundedIcon className={styles.zoominIcon} onClick={() => { handelZoom(); }} />
                      <RemoveCircleOutlineRoundedIcon className={styles.zoomOutIcon} onClick={() => { handelZoomOut(); }} />
                    </div>
                    <Clickable onClick={() => { exitFullScreen(); }} className={styles.Clickable}>
                      <FormattedMessage id="training.pdf.exitfscreen" defaultMessage="Exit Fullscreen" />
                    </Clickable>
                  </div>
                </div>
                {(nextSectionId || subSection?.file_name?.split('.').pop() === 'pdf')
                  && (toggle() || pageNumberProps < numPagesProps) && next_section && (
                    <NavigateNextOutlinedIcon fontSize="large" onClick={() => { handleNextPrev(true); }} className={styles.nextFixedArrow} />
                  )}
                {((subSection?.file_name?.split('.').pop() === 'pdf'
                  && pageNumberProps > 1)
                  || (!(sectionIndex === 0 && subSectionIdIndex === 0)
                    && prevSectionId
                    && prevSubSectionId)) && showPrevious(
                      parentSection?.additional_config,
                      parentSection?.quiz,
                      params.subId
                    ) && (
                    <NavigateBeforeOutlinedIcon fontSize="large" onClick={() => { handleNextPrev(false); }} className={styles.prevFixedArrow} />
                  )}
              </>
            )}
            <>
              {pdf.preview ? (
                <>
                  <Document
                    file={pdf.preview}
                    onLoadSuccess={this.onDocumentLoadSuccess}
                    loading={<Loading loadingStatus />}
                  >
                    <div className={styles.pageContent}>
                      <Page pageNumber={pageNumberProps ?? pageNumber}
                        renderMode="canvas"
                        scale={scale}
                        className={styles.zoom}
                        height={(adp || showControls) ? '' : '520'}
                        width={adp ? width : ''}
                      />
                    </div>
                  </Document>
                  <div className={classnames(styles.pdf, pageNumberProps && 'd-none')}>
                    <div className={styles.left}>
                      {pageNumber > 1 && (
                        <Clickable className={styles.prev} onClick={() => this.setState({ pageNumber: pageNumber - 1 })}>
                          <FormattedMessage id="wildlife.settings.pdf.prev" defaulMessage="Prev" />
                        </Clickable>
                      )}
                      <h4>
                        <FormattedMessage id="wildlife.settings.pdf.page" defaulMessage="Page" />
                        {' '}
                        {pageNumber}
                        {' /'}
                        {numPages}
                      </h4>
                    </div>
                    <div className={styles.right}>
                      {(pageNumber < numPages || handleNextPrev) && (
                        <Clickable className={styles.next} onClick={() => {
                          this.setState({ pageNumber: pageNumber === numPages ? 1 : pageNumber + 1 });
                          if (pageNumber === numPages) handleNextPrev(true);
                        }}
                        >
                          <FormattedMessage id="inspections.new.next" defaulMessage="Next" />
                        </Clickable>
                      )}
                    </div>
                  </div>
                </>
              ) : (
                <a href={pdf.url} target="_blank" rel="noopener noreferrer">
                  {pdf.file_name}
                </a>
              )}
            </>
          </div>
        </div>
      </>
    );
  }
}

DisplayPDF.propTypes = {
  pdf: PropTypes.shape({}).isRequired
};


export default DisplayPDF;
